import * as actions from './actionTypes';
import { getPublicDiscoveryFeed } from '../../Services/demandLifecycle';

export const getUsers = (payload) => ({ type: actions.GET_USERS, payload });
export const getArtisans = (payload) => ({ type: actions.GET_ARTISANS, payload });

const message = (error) => {
  const raw = String(error?.message || '').trim();
  const code = String(error?.code || '').toLowerCase();
  if (raw && !/^internal$/i.test(raw) && !code.includes('internal')) return raw;
  return 'Impossible de charger les profils publics pour le moment.';
};

const normalizePublicArtisan = (data = {}) => ({
  ...data,
  user_id: data.user_id || data.id || '',
  firstName: data.display_name || data.firstName || 'Artisan',
  artisan_rating: Number(data.average_rating || data.trust?.average_rating || data.artisan_rating || 0),
  total_num_jobs: Number(data.verified_projects || data.total_num_jobs || 0),
});

const loadPublicArtisans = async () => {
  const feed = await getPublicDiscoveryFeed();
  return (Array.isArray(feed?.artisans) ? feed.artisans : []).map(normalizePublicArtisan);
};

export function getUsersAPI() {
  // Compatibility alias retained for older screens. Public discovery now goes
  // through the backend projection so a browser collection-group permission
  // cannot break a freshly-created client account.
  return async (dispatch) => {
    dispatch({ type: actions.USERS_LOADING, payload: true });
    try {
      dispatch(getUsers(await loadPublicArtisans()));
      return () => undefined;
    } catch (error) {
      dispatch({ type: actions.USERS_FAIL, payload: message(error) });
      return () => undefined;
    } finally {
      dispatch({ type: actions.USERS_LOADING, payload: false });
    }
  };
}

export function getBestArtisanAPI() {
  return async (dispatch) => {
    dispatch({ type: actions.ARTISANS_LOADING, payload: true });
    try {
      dispatch(getArtisans(await loadPublicArtisans()));
      return () => undefined;
    } catch (error) {
      dispatch({ type: actions.ARTISANS_FAIL, payload: message(error) });
      return () => undefined;
    } finally {
      dispatch({ type: actions.ARTISANS_LOADING, payload: false });
    }
  };
}
